// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"26a720d9","815":"2f7e9b2b"}[chunkId] + ".chunk.css";
};